<template>
  <div class="app-container">
    <list ref="list">
      <template slot="column">
        <!-- <el-table-column label="操作" fixed="right" align="center" width="60"> -->
        <el-table-column label="操作" fixed="right" align="center" width="160">
          <template slot-scope="{ row }">
            <el-button v-if="$permission.canRead()" type="text" @click="_checkTeam(row)">按部门查看</el-button>
            <el-button v-if="$permission.canRead()" type="text" @click="_checkshebei(row)">按设备查看</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <team-dialog ref="teamDialog"></team-dialog>
    <equipment-dialog ref="equipmentDialog"></equipment-dialog>
  </div>
</template>
<script>
import curdMixins from '@/mixins/trend/curd'
import list from '@/components/production/scheduling/historicalscheduling/list'

import teamDialog from '@/components/production/scheduling/historicalscheduling/teamDialog'

import equipmentDialog from '@/components/production/scheduling/historicalscheduling/equipmentDialog'

// import editDialog from '@/components/production/clothmanagement/cloth/editDialog'

export default {
  mixins: [curdMixins],
  components: {
    list,
    teamDialog,
    equipmentDialog
  },
  methods: {
    _checkTeam(row) {
      // this.$refs.teamDialog.openDetailsById(1);
      this.$refs.teamDialog.alreadyData = []
      this.$refs.teamDialog.notData = []
      this.$refs.teamDialog.openEdit(row)
    },
    _checkshebei(row) {
      // this.$refs.equipmentDialog.openDetailsById(1);
      this.$refs.equipmentDialog.alreadyData = []
      this.$refs.equipmentDialog.notData = []
      this.$refs.equipmentDialog.openEdit(row)
    }
  }
}
</script>